var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSocialIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.57647 10.1432C1.57647 10.1432 0.870605 10.1432 0.870605 9.4389C0.870605 8.73458 1.57647 6.62163 5.10581 6.62163C8.63514 6.62163 9.34101 8.73458 9.34101 9.4389C9.34101 10.1432 8.63514 10.1432 8.63514 10.1432H1.57647ZM5.10581 5.91731C5.66743 5.91731 6.20605 5.6947 6.60318 5.29844C7.00031 4.90219 7.22341 4.36475 7.22341 3.80436C7.22341 3.24397 7.00031 2.70653 6.60318 2.31028C6.20605 1.91402 5.66743 1.69141 5.10581 1.69141C4.54419 1.69141 4.00557 1.91402 3.60844 2.31028C3.21131 2.70653 2.98821 3.24397 2.98821 3.80436C2.98821 4.36475 3.21131 4.90219 3.60844 5.29844C4.00557 5.6947 4.54419 5.91731 5.10581 5.91731Z",
    fill: "#FFB801"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20117 6.84562C9.01367 7.30592 9.46348 7.92188 9.69408 8.45485H12.8231C12.8231 8.45485 13.2937 8.45485 13.2937 7.98531C13.2937 7.51576 12.8231 6.10713 10.4702 6.10713C9.31727 6.10713 8.61628 6.44537 8.20117 6.84562ZM11.4685 5.225C11.2037 5.48917 10.8447 5.63758 10.4702 5.63758C10.0958 5.63758 9.73674 5.48917 9.47199 5.225C9.20724 4.96083 9.0585 4.60254 9.0585 4.22895C9.0585 3.85535 9.20724 3.49706 9.47199 3.23289C9.73674 2.96872 10.0958 2.82031 10.4702 2.82031C10.8447 2.82031 11.2037 2.96872 11.4685 3.23289C11.7332 3.49706 11.882 3.85535 11.882 4.22895C11.882 4.60254 11.7332 4.96083 11.4685 5.225Z",
    fill: "#FFB801"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSocialIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/social-icon.4d0f188ba63469ebeadc893e2bff01eb.svg";